<div style="position: relative;" class="event-main-container ">

  <div class="select-all-container">

    <input [formControl]="selectAllFormControl" type="checkbox" />
    <label for="selectAll"> Select All</label>
    </div>
    <div class="evnt_container" *ngIf="events" [ngClass]="{
  'disabled-event-tab' : noDeviceFound
}">
  <div class="evnt_box" *ngFor="let event of events">
    <input
      type="checkbox"
      [checked]="event['checked']"
      [id]="event['event_icon_add']"
      (input)="handleCheckbox(event['event_icon_add'])"
    />
    <p class="evnt_name">
      {{ event["event_name"] }}
    </p>
    <ng-template #otherEvent>
      <p class="evnt_name">
        {{ direction == "IN" ? event["event_name"] : 'Sign Out Locations' }}
      </p>
    </ng-template>
    <img
      [src]="replayImgSrc + 'assets/icons/' + event['event_icon_add'] + '.svg'"
      class="evnt_icon"
      [ngClass]="{ 'route-img': event['event_icon_add'] === 'planned-route' || event['event_icon_add'] === 'over-speeding' || event['event_icon_add'] === 'no-gps'   }"
      [alt]="event['event_icon_add']"
    />
  </div>

</div>

<div class="no-device-found" *ngIf="noDeviceFound">
  No Health Logs data found!
</div>
</div>